import { UploadErrorCode } from '@fabric-app/types/upload';
import { UploadError } from '../upload.error.js';

const executeFetchUpload = async ({ method, url, headers, onProgress, abortSignal, file }) => {
  const fetchOptions = {
    method,
    headers,
    signal: abortSignal,
    body: file
  };
  if (onProgress && typeof ReadableStream !== "undefined" && "stream" in file) {
    fetchOptions.body = await createProgressStream(file, onProgress);
  }
  const response = await fetch(url, fetchOptions);
  if (!response.ok) {
    throw new UploadError(UploadErrorCode.FileUploadFailed, `Upload failed with status ${response.status}`, true, false);
  }
  return {
    responseHeaders: Object.fromEntries(response.headers.entries().map(([key, value]) => [
      key.toLowerCase(),
      value
    ]))
  };
};
const createProgressStream = async (file, onProgress) => {
  const contentLength = file.size;
  let loaded = 0;
  const updateProgress = (bytes) => {
    loaded += bytes;
    onProgress(loaded, contentLength);
  };
  return new Response(new ReadableStream({
    start(controller) {
      const reader = file.stream().getReader();
      function pump() {
        return reader.read().then(({ done, value }) => {
          if (done) {
            controller.close();
            return;
          }
          if (value) {
            updateProgress(value.length);
            controller.enqueue(value);
          }
          return pump();
        });
      }
      return pump();
    }
  })).blob();
};

export { createProgressStream, executeFetchUpload };
//# sourceMappingURL=executeFetchUpload.js.map
